import {ADICIONAR_FORMAS_PAGAMENTO} from '../types'

export function adicionarFormasPagamento (formasPagamento) {
  return {
    type: ADICIONAR_FORMAS_PAGAMENTO,
    payload: formasPagamento
  }
}

